import { Menu, MenuItem } from '@mui/material';

export type LabwareMenuAction = {
  actionId: string;
  label: string;
};

export type MenuOptions = {
  onMenuAction: (labwareId: string, actionId: string) => void;
  menuActions: LabwareMenuAction[];
};

type Props = {
  anchorEl: HTMLElement | null;
  labwareId: string | null;
  menuOptions: MenuOptions;
  onClose: () => void;
};

export const LabwareMenu = ({
  anchorEl,
  labwareId,
  menuOptions,
  onClose,
}: Props) => {
  const handleMenuItemClick = (actionId: string) => {
    if (labwareId) {
      menuOptions.onMenuAction(labwareId, actionId);
    }
    onClose();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      {menuOptions.menuActions.map((action) => (
        <MenuItem
          key={action.actionId}
          onClick={() => handleMenuItemClick(action.actionId)}
        >
          {action.label}
        </MenuItem>
      ))}
    </Menu>
  );
};
